export function formatResidentListProcessSubtitle(
  residentName: string,
  applicantId: string | number,
) {
  return [residentName, applicantId ? `Applicant ${applicantId}` : ''].filter(Boolean).join(' • ')
}
